import { useQuery } from '@tanstack/react-query';

import { MEMBER_KEYS } from '@/constants/queryKeys';
import { errorUtils } from '@/services/errors';
import { membersService } from '@/services/members';
import { useStaffSession } from '@/hooks/auth';

const useMemberVisibility = (memberID: string, isEnabled: boolean = true) => {
  const { data: session } = useStaffSession();

  return useQuery({
    queryKey: MEMBER_KEYS.visibility(memberID),
    queryFn: async () => errorUtils.unwrap(await membersService.readVisibility(memberID)),
    enabled: isEnabled && memberID.length > 0 && session?.stage === 'ready',
  });
};

export {
  useMemberVisibility,
};
